import Footer from 'components/shared/Footer/Footer'
import PropTypes from 'prop-types'
import React from 'react'
import { translate } from 'react-i18next'

import TwoCardBlock from './TwoCardBlock/TwoCardBlock'
import FeaturedSection from './FeaturedSection/FeaturedSection'
import Hardware from './Hardware/Hardware'
import Hero from './Hero/Hero'
import PathsSection from './PathsSection/PathsSection'

export const Homepage = ({ i18n, collections, featured }) => {
  const loadedSections = [
    'hardware',
    !collections.loading && !collections.error ? 'paths' : [],
    !featured.loading && !featured.error ? 'project' : [],
  ]

  const gtm = {
    category: 'Homepage',
    label_prefix: null,
    label: null,
  }

  return (
    <div className="c-homepage">
      <Hero loadedSections={loadedSections} locale={i18n.language} gtm={gtm} />
      {loadedSections.includes('paths') && (
        <PathsSection locale={i18n.language} gtm={gtm} />
      )}
      {loadedSections.includes('project') && (
        <FeaturedSection locale={i18n.language} featured={featured} gtm={gtm} />
      )}
      <TwoCardBlock locale={i18n.language} gtm={gtm} />
      <Hardware locale={i18n.language} gtm={gtm} />
      <Footer
        text="project.footer.feedback.homepage.text"
        userID="homepage-footer-user-id"
      />
    </div>
  )
}

Homepage.propTypes = {
  i18n: PropTypes.object.isRequired,
  collections: PropTypes.object.isRequired,
  featured: PropTypes.object,
}

export default translate('translations')(Homepage)
